/*
 * $Id:: model.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { downloadFile } from '../../common/utils/service';
import { me } from '../AuthenticatedPage/authenticationSlice';
import { fetchApplicationsPaginated, fetchApplicationsExport } from '../MyApplicationsPage/service';
import { SLICE_NAME } from './constants';
import { deleteApplication, resumeApplication, lockApplication, unlockApplication } from './service';

function* requestDraftApplications(action) {
    const { userId, parentUserId } = yield select(me);
    yield all([put({ type: `${SLICE_NAME}/loading`, payload: true }), put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(fetchApplicationsPaginated, {
        ...action.payload,
        userId: parentUserId ? parentUserId : userId,
    });
    if (!response.error) {
        yield put({
            type: `${SLICE_NAME}/list`,
            payload: response,
        });
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: response.error.description });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* getDraftApplications() {
    yield takeLatest(`${SLICE_NAME}/requestDraftApplications`, requestDraftApplications);
}

function* requestDraftApplicationDelete(action) {
    yield all([put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(deleteApplication, {
        ...action.payload,
    });
    if (!response.error) {
        // update table list
        yield call(requestDraftApplications, action.payload.actionParams);
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: response.error.code === 403 ? response.error : response.error.description });
    }
}

function* deleteDraftApplication() {
    yield takeLatest(`${SLICE_NAME}/requestDraftApplicationDelete`, requestDraftApplicationDelete);
}

function* requestResumeDraftApplication(action) {
    yield all([put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(resumeApplication, {
        ...action.payload,
    });
    if (!response.error) {
        const redirectUrl = response.url;
        if (!!redirectUrl) {
            window.open(redirectUrl, '_blank');
        }
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: response.error.code === 403 ? response.error : response.error.description });
    }
}

function* resumeDraftApplication() {
    yield takeLatest(`${SLICE_NAME}/requestResumeDraftApplication`, requestResumeDraftApplication);
}

function* requestLockDraftApplication(action) {
    yield all([put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(lockApplication, {
        ...action.payload,
    });
    if (!response.error) {
        // update table list
        yield call(requestDraftApplications, action.payload.actionParams);
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: response.error.description });
    }
}

function* lockDraftApplication() {
    yield takeLatest(`${SLICE_NAME}/requestLockDraftApplication`, requestLockDraftApplication);
}

function* requestUnlockDraftApplication(action) {
    yield all([put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(unlockApplication, {
        ...action.payload,
    });
    if (!response.error) {
        // update table list
        yield call(requestDraftApplications, action.payload.actionParams);
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: response.error.description });
    }
}

function* unlockDraftApplication() {
    yield takeLatest(`${SLICE_NAME}/requestUnlockDraftApplication`, requestUnlockDraftApplication);
}

function* requestMyDraftsExport(action) {
    yield all([put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(fetchApplicationsExport, {
        ...action.payload,
    });
    if (!response.error) {
        downloadFile(response);
    } else {
        yield put({ type: `${SLICE_NAME}/error`, payload: response.error.description });
    }
}

function* getMyDraftsExport() {
    yield takeLatest(`${SLICE_NAME}/requestMyDraftsExport`, requestMyDraftsExport);
}

export { getDraftApplications, deleteDraftApplication, resumeDraftApplication, getMyDraftsExport, lockDraftApplication, unlockDraftApplication };
